import Controller from "sap/ui/core/mvc/Controller";
import Model from "sap/ui/model/Model";
import JSONModel from "sap/ui/model/json/JSONModel";
import Navigation from "ips/ac/base/handler/Navigation";
import Util from "ips/ac/util/Util";
import { Button$PressEvent } from "sap/m/Button";
import Fragment from "ips/ac/base/handler/Fragment";
import ManagedObject from "sap/ui/base/ManagedObject";
import Control from "sap/ui/core/Control";

/**
 * @namespace ips.ac
 */

export default class BaseTypedController extends Controller {
  public onInit() {
    this.getView().setModel(Util.getModel("SVH"), "SVH");
  }

  public setModel(model: Model, name?: string) {
    return this.getView().setModel(model, name);
  }

  public getModel<TModel extends Model>(name?: string): TModel {
    const model = this.getView().getModel(name) || this.getOwnerComponent()?.getModel(name);
    return model as TModel;
  }

  public navTo(route: string, data: object = {}, replace = false) {
    Navigation.navTo(route, data, replace);
  }

  public setRouteDisplayData(routeName: string, data: object) {
    this.getModel<JSONModel>("app").setProperty("/appStateData", { [routeName]: data });
  }

  public getRouteDisplayData(routeName: string) {
    return this.getModel<JSONModel>("app").getProperty(`/appStateData/${routeName}`);
  }

  public findParentControl(className: string, source?: ManagedObject) {
    return Util.findParentControl(className, source ?? this.getView());
  }

  public async onOpenFragmentPopup(oEvent: Button$PressEvent) {
    await Fragment.openFragmentPopup(this, oEvent);
  }

  public async getXmlFragment(id: string): Promise<Control> {
    return Fragment.getFragment(id, this);
  }

  public onClosePopup(oEvent: Button$PressEvent, oTarget?: ManagedObject) {
    Fragment.closePopup(oEvent, oTarget);
  }
}

